const css = `._8qjEOW__NotificationPopoverList{position:absolute;top:73px;right:17px}._8qjEOW__NotificationPopoverList>div{margin-bottom:16px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"NotificationPopoverList":"_8qjEOW__NotificationPopoverList"};
